// components/shared/Input.jsx
const Input = ({
    type = 'text',
    label,
    name,
    value,
    onChange,
    error,
    placeholder,
    required = false,
    className = ''
  }) => {
    return (
      <div className="input-group">
        {label && (
          <label htmlFor={name} className="input-group__label">
            {label} {required && <span className="input-group__required">*</span>}
          </label>
        )}
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`input-group__input ${error ? 'input-group__input--error' : ''} ${className}`}
          required={required}
        />
        {error && <span className="input-group__error">{error}</span>}
      </div>
    );
  };

export default Input;